import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  type Signal,
} from '@angular/core';
import { NgCommonModule } from '@principle-theorem/ng-shared';
import { PatientStatus } from '@principle-theorem/principle-core/interfaces';

const STATUS_COLOUR_CLASSES: Record<PatientStatus, string> = {
  [PatientStatus.Active]: 'bg-primary-50 text-primary-700',
  [PatientStatus.Lead]: 'bg-amber-100 text-amber-800',
  [PatientStatus.Inactive]: 'bg-warn-100 text-warn-800',
  [PatientStatus.Blocked]: 'bg-warn-100 text-warn-800',
  [PatientStatus.Deceased]: 'bg-warn-100 text-warn-800',
};

@Component({
  selector: 'pr-patient-status-chip',
  templateUrl: './patient-status-chip.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgCommonModule],
})
export class PatientStatusChipComponent {
  readonly status = input.required<PatientStatus>();
  readonly colourClasses: Signal<string> = computed(
    () => STATUS_COLOUR_CLASSES[this.status()]
  );
}
